export const THUMBNAIL_CREATE_RESET = 'THUMBNAIL_CREATE_RESET'
export const THUMBNAIL_CREATE_SET_CREATED = 'THUMBNAIL_CREATE_SET_CREATED'
export const THUMBNAIL_CREATE_SET_ERROR = 'THUMBNAIL_CREATE_SET_ERROR'
export const THUMBNAIL_CREATE_SET_VIOLATIONS = 'THUMBNAIL_CREATE_SET_VIOLATIONS'
export const THUMBNAIL_CREATE_SET_LOADING = 'THUMBNAIL_CREATE_SET_LOADING'
